var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDisposables(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon_disposables"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_disposables",
    clipPath: "url(#clip-icon_disposables)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M16,8H12v2H7.938l.887-.5L16.547,5.1h0l.869-.5-.5-.869-.913.52a2.5,2.5,0,0,0-3.118-.527l-1.3.742A2,2,0,0,0,8.109,6.451h0l-1.3.741a2.5,2.5,0,0,0-1.14,2.95l-.913.519.494.869.8-.454.734,8.8A1.184,1.184,0,0,0,7.946,21h8.108a1.181,1.181,0,0,0,1.165-1.11L18.043,10H16ZM9.353,4.593a1,1,0,0,1,1.364.375l-1.738.989A1,1,0,0,1,9.353,4.593ZM6.6,8.969a1.487,1.487,0,0,1,.7-.906l1.658-.944,3.123-1.776h0l1.3-.741h0a1.5,1.5,0,0,1,1.724.169L6.565,9.631A1.471,1.471,0,0,1,6.6,8.969ZM13,9h2v1H13ZM10,20V13.4a.4.4,0,0,1,.4-.4h3.2a.4.4,0,0,1,.4.4V20Zm6.957-9-.735,8.815a.183.183,0,0,1-.168.185H15V13.4A1.4,1.4,0,0,0,13.6,12H10.4A1.4,1.4,0,0,0,9,13.4V20H7.946a.187.187,0,0,1-.169-.194L7.043,11h9.914Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M18.5,6A1.5,1.5,0,1,0,20,7.5,1.5,1.5,0,0,0,18.5,6Zm0,2a.5.5,0,1,1,.5-.5A.5.5,0,0,1,18.5,8Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDisposables);
export default __webpack_public_path__ + "static/media/icon_disposables.0f47c729c43f8e1c9e781284b8424706.svg";
export { ForwardRef as ReactComponent };